module.exports = __webpack_public_path__ + "img/prismnet.c40e4b22.png";